import ClienteUpdate from './ClienteUpdate.vue'

export default ClienteUpdate
